export default {
    product: {
        description: {
            more: "Di più"
        },
        added: "Aggiunto al carrello"
    }
}